import { render, staticRenderFns } from "./writeoff-record.vue?vue&type=template&id=e2316d5e&scoped=true&"
import script from "./writeoff-record.vue?vue&type=script&lang=js&"
export * from "./writeoff-record.vue?vue&type=script&lang=js&"
import style0 from "./writeoff-record.vue?vue&type=style&index=0&id=e2316d5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2316d5e",
  null
  
)

export default component.exports